export default {
  orderBy: 'Ordenar por',
  order: {
    relevance: 'Relevancia',
    priceAsc: 'Precio - Menor a Mayor',
    priceDesc: 'Precio - Mayor a Menor',
    title: 'Título',
  },
  filters: {
    title: 'Filtros',
  },
  clear: 'Limpiar',
  clearAll: 'Borrar todo',
  category: {
    title: 'Categoría',
  },
  availability: {
    title: 'Disponibilidad',
    inStock: 'En stock',
  },
  showMore: 'Ver más',
  taxesShipping: '+ Impuestos y envío',
  showLess: 'Ver menos',
  facets: {
    price: 'Rango de precios',
    brands: 'Marcas',
    seller: 'Vendedor',
  },
  price: {
    under: 'Menos de',
    andOver: 'y más',
  },
  input: {
    refine: 'Refinar...',
  },
  checkprice: {
    apply: 'Aplicar',
    min: 'Mín',
    max: 'Máx',
    error: 'Valor máximo inválido !',
  },
  badges: { // Keep as short as possible
    verifiedSeller: 'Vendedor verificada',
    outOfStock: 'Agotado',
    delivery: 'Entrega',
  },
  results: { // 123 Results for 'samsung'. (Corrected from 'sansung')
    results: 'Resultados',
    for: 'para',
    correctedFrom: 'Corregido de',
    filterResults: 'Filtrar resultados',
  },
}
